module.exports = __webpack_public_path__ + "static/media/perks.e5fff728.png";